import React from 'react';
import DataTables from '../../CommonDataTable/DataTable';
import config from '../../../../config/config';
import apiCalls from '../../../../config/apiCalls'
import ViewModal from '../../CommonModals/viewModal';
import NewUserModal from '../../CommonModals/NewUserModal';
import showToasterMessage from '../../../UI/ToasterMessage/toasterMessage';
import FormModal from '../../../Form/FormModal';
import store from '../../../App/store';
import filePath from "../../../../config/configSampleFiles";
import fetchMethodRequest from "../../../../config/service"
import RolePermissions from '../../CommonModals/Permissions';
import OrdersEdit from '../OrdersEdit';
// config file
export default class Teachers extends React.Component {
  financialClassTypes = [    
    {
      "label": "Managed Care",
      "value": "Managed Care",
      "color": "primary"
    },
    {
      "label": "Medicaid",
      "value": "Medicaid",
      "color": "primary"
    },
    {
      "label": "Medicare",
      "value": "Medicare",
      "color": "primary"
    }, 
    {
      "label": "No Charge",
      "value": "No Charge",
      "color": "primary"
    },    
    {
      "label": "PIP",
      "value": "PIP",
      "color": "primary"
    },
    {
      "label": "Self Pay",
      "value": "Self Pay",
      "color": "primary"
    },
    {
      "label": "Slip & Fall",
      "value": "Slip & Fall",
      "color": "primary"
    },
    {
      "label": "Workmans Comp",
      "value": "Workmans Comp",
      "color": "primary"
    }    
  ];
  priorityTypes=[
    {
      "label": "Routine",
      "value": "routine",
      "color": "primary"
    },
    {
      "label": "Stat",
      "value": "Stat",
      "color": "primary"
    },
    {
      "label": "Stat & Call",
      "value": "Stat & Call",
      "color": "primary"
    }

  ]
  constructor(props) {
    super(props);
    this.state = {
      languageData: '',
      rolePermission: "",
      rolesList: [],
      editSelectedRecord:window.location.href.includes("edit"),
      addSelectedRecord:window.location.href.includes("create"),
      viewSelectedRecord:window.location.href.includes("view"),	
    };
    this.getRoleListFromServer()
  }

  static getDerivedStateFromProps(props, state) {
    let storeData = store.getState()
    let languageData = storeData && storeData.settingsData && storeData.settingsData.settings && storeData.settingsData.settings.languageTranslation ? storeData.settingsData.settings.languageTranslation : ""
    return { languageData: languageData };
  }
  componentDidMount = () => {
    //Screen permisions value can be edit,view, no view
    let screenPermissions = RolePermissions.screenPermissions('Orders');
    if (screenPermissions) {
      this.setState({
        rolePermission: screenPermissions
      })
    }
    // this.getRoleListFromServer()
  }
  setData = (props) => {
    let rowData = {}
    if (props && props.match && props.match.params && props.match.params.id) {
      rowData["_id"] = JSON.parse(props.match.params.id)
      return rowData
    }
  }
  getRoleListFromServer = async () => {
    let filterCriteria = {},
      url;
    filterCriteria.direction = "asc";
    url = `roles?filter=${JSON.stringify(filterCriteria)}`;
    fetchMethodRequest('GET', url)
      .then(async (res) => {
        if (res && res.roles && res.roles.length > 0) {
          let rolesList = []
          for (let obj of res.roles) {
            if (obj.role) rolesList.push({ value: obj.role, label: obj.role });
          }

          await this.setState({ rolesList: rolesList });
        }
      }).catch((err) => { return err })
  };
  getTableFields = () => {
    let { languageData } = this.state
    let roleTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Admin',
        value: 'Admin'
      },
      {
        label: 'Super Admin',
        value: 'Super Admin'
      },
      {
        label: 'User',
        value: 'User'
      },
    ];
    let StatusTypes = [
      {
        label: 'All',
        value: null
      },
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      }
    ];
    let data = [
      {
        "textAlign": "center",
        "width": 47,
        "field": "Check Box",
        "label": "Check Box",
        "fieldType": "multiple",
        "header": "",
        "selectionMode": "multiple",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
      {
        "textAlign": "center",
        "width": 47,
        "field": "Sno",
        "label": "SNo",
        "header": "SNo",
        "filter": false,
        "sortable": false,
        "placeholder": "Search",
        "show": true,
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "patientName",
        "type": "text",
        "placeholder": "Patient",
        "label": "Patient",
        "width": "180px",
        "header": "Patient",
        "derivedValue": "patient=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "patientName",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1012,
        "searchField": "displayName",
        "fieldType": "Link",
        "populteFields": [],
        "displayFields": [
          "name"
        ],
        "controllerName": "patients",
        "searchApi": "patient",
        "isMultiple": false,
        "textAlign": "Center",
        "show": true,
        "field": "patientName",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true        
      },
      // {
      //   "name": "patients_name",
      //   "type": "text",
      //   "placeholder": "patients_name",
      //   "label": "patients_name",
      //   "header": "patients name",
      //   "width": 110,
      //   "parentField": "patient",
      //   "id": "patients_name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "name",
      //   "show": true,
      //   "field": "patients_name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "provider",
      //   "type": "relateAutoComplete",
      //   "placeholder": "Provider",
      //   "label": "Provider",
      //   "width": "90px",
      //   "header": "Provider",
      //   "derivedValue": "provider=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "provider",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "false",
      //   "controllerId": 1010,
      //   "searchField": "name",
      //   "fieldType": "relateAutoComplete",
      //   "populteFields": [],
      //   "displayFields": [
      //     "name"
      //   ],
      //   "controllerName": "providers",
      //   "searchApi": "providerss",
      //   "isMultiple": false,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "provider",
      //   "showOrHideFields": [],
      //   "fieldName": "provider",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "providers_name",
      //   "type": "text",
      //   "placeholder": "providers_name",
      //   "label": "providers_name",
      //   "header": "providers name",
      //   "width": 110,
      //   "parentField": "provider",
      //   "id": "providers_name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "name",
      //   "show": true,
      //   "field": "providers_name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "scanCptCode",
        "type": "text",
        "placeholder": "Procedure  code",
        "label": "Procedure  code",
        "width": "200px",
        "header": "Procedure  code",
        "derivedValue": "Scans=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "Scans",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "false",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1010,       
        "fieldType": "text",             
        "isMultiple": true,
        "textAlign": "Center",
        "show": true,
        "field": "scanCptCodes",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "fieldName": "scanCptCode",
        "filter":true,
        "sortable": true,

      },      
      {
        "name": "scanDescription",
        "type": "text",
        "placeholder": "Procedures",
        "label": "scanDescription",
        "header": "Procedures",
        "width": "350px",
        "parentField": "scans",
        "id": "scanDescription",
        "displayinlist": "true",
        "fieldType": "text",
        "textAlign": "Center",        
        "show": true,
        "field": "scanDescriptions",
        "mobile": true,
        "displayInSettings": true,
        "filter":true,
        "sortable": true,
      },
      {
        "name": "physicianName",
        "type": "text",
        "placeholder": "Physician",
        "label": "Physician",
        "width": "150px",
        "addFormOrder": 17,
        "editFormOrder": 17,
        "header": "Physician",
        "derivedValue": "physician=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "physicianName",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1008,
        "searchField": "displayName",
        "fieldType": "text",
        "populteFields": [],
        "displayFields": [
          "displayName"
        ],
        "controllerName": "provideremployee",
        "searchApi": "provideremployees",
        "isMultiple": false,
        "textAlign": "Center",
        "show": true,
        "field": "physicianName",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },      
      // {
      //   "name": "scanDescription",
      //   "type": "relateAutoComplete",
      //   "placeholder": "Scan Description",
      //   "label": "Scan Description",
      //   "width": "200px",
      //   "header": "Scan Description",
      //   "derivedValue": "Scans=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "Scans",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "false",
      //   "isFieldRequired": "true",
      //   "required": true,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "false",
      //   "controllerId": 1010,
      //   "searchField": "description",
      //   "fieldType": "relateAutoComplete",
      //   "populteFields": [],
      //   "displayFields": [
      //     "description"
      //   ],
      //   "controllerName": "scans",
      //   "searchApi": "scans",
      //   "isMultiple": true,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "scans",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true,
      //   "fieldName": "scanDescription",
      // },
      {
        "name": "facilityName",
        "type": "text",
        "placeholder": "Facility",
        "label": "Facility",
        "width": "150px",
        "header": "Facility",
        "derivedValue": "facility=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "actions": [],
        "actionsNumber": [],
        "id": "facilityName",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1011,
        "searchField": "name",
        "fieldType": "text",
        "populteFields": [],
        "displayFields": [
          "name"
        ],
        "controllerName": "facilities",
        "searchApi": "facilitiess",
        "isMultiple": false,
        "textAlign": "Center",
        "show": true,
        "field": "facilityName",
        "showOrHideFields": [],
        "fieldName": "facilityName",
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      // {
      //   "name": "facilities_name",
      //   "type": "text",
      //   "placeholder": "facilities_name",
      //   "label": "facilities_name",
      //   "header": "facilities name",
      //   "width": 110,
      //   "parentField": "facility",
      //   "id": "facilities_name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "name",
      //   "show": true,
      //   "field": "facilities_name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "phoneNumber",
      //   "type": "text",
      //   "placeholder": "Phone Number",
      //   "label": "Phone Number",
      //   "width": "90px",
      //   "header": "Phone Number",
      //   "derivedValue": "phoneNumber=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "phoneNumber",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "phoneNumber",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "speciality",
      //   "type": "text",
      //   "placeholder": "Speciality",
      //   "label": "Speciality",
      //   "width": "90px",
      //   "header": "Speciality",
      //   "derivedValue": "speciality=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "speciality",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "speciality",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "Npi",
      //   "type": "text",
      //   "placeholder": "NPI",
      //   "label": "NPI",
      //   "width": "90px",
      //   "header": "NPI",
      //   "derivedValue": "Npi=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "Npi",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "true",
      //   "required": true,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "Npi",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "fax",
      //   "type": "text",
      //   "placeholder": "Fax",
      //   "label": "Fax",
      //   "width": "90px",
      //   "header": "Fax",
      //   "derivedValue": "fax=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "fax",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "fax",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "nextAppointment",
        "type": "date",
        "placeholder": "Next Appointment",
        "label": "Next Appointment",
        "width": "180px",
        "header": "Next Appointment Date",
        "derivedValue": "nextAppointment=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "fieldType": "date",
        "actions": [],
        "actionsNumber": [],
        "id": "nextAppointment",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "show": true,
        "field": "nextAppointment",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "filter":true
      },
      // {
      //   "name": "address",
      //   "type": "textarea",
      //   "placeholder": "Address",
      //   "label": "Address",
      //   "width": "90px",
      //   "header": "Address",
      //   "derivedValue": "address=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "address",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "true",
      //   "controllerId": null,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "address",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "createdByName",
        "type": "Text",
        "placeholder": "Created By",
        "label": "Created By",
        "width": 120,
        "header": "Created By",
        "id": "createdByName",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "field": "createdByName",
        "mobile": true,
        "filter": true,
        "displayInSettings": true
      },
      {
        "name": "updatedByName",
        "type": "Text",
        "placeholder": "Updated By",
        "label": "Updated By",
        "width": 120,
        "header": "Updated By",
        "id": "updatedByName",
        "displayinlist": "true",
        "fieldType": "Text",
        "textAlign": "Center",
        "show": true,
        "filter": true,
        "field": "updatedByName",
        "mobile": true,
        "displayInSettings": true
      },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": "120px",
        "header": "Updated",
        "derivedValue": "updated=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "updated",
        "fieldType": "date",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "updated",
        "mobile": true,
        "displayInSettings": true,
        "sortable":true,
        "filter":true
      },
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": "120px",
        "fieldType": "date",
        "header": "Created",
        "derivedValue": "created=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "textAlign": "Center",
        "disabled": true,
        "show": true,
        "field": "created",
        "mobile": true,
        "displayInSettings": true,
        "sortable":true,
        "filter":true
      },
     
      // {
      //   "name": "hospitalemployee_Name",
      //   "type": "text",
      //   "placeholder": "hospitalemployee_Name",
      //   "label": "hospitalemployee_Name",
      //   "header": "hospitalemployee Name",
      //   "width": 110,
      //   "parentField": "physician",
      //   "id": "hospitalemployee_Name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "Name",
      //   "show": true,
      //   "field": "hospitalemployee_Name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "facilityStaff",
      //   "type": "relateAutoComplete",
      //   "placeholder": "Facility Staff",
      //   "label": "Facility Staff",
      //   "width": "90px",
      //   "addFormOrder": 18,
      //   "editFormOrder": 18,
      //   "header": "Facility Staff",
      //   "derivedValue": "facilityStaff=undefined",
      //   "capitalizeTableText": false,
      //   "sortable": false,
      //   "actions": [],
      //   "actionsNumber": [],
      //   "id": "facilityStaff",
      //   "displayinaddForm": "true",
      //   "displayineditForm": "true",
      //   "displayinlist": "true",
      //   "isFieldRequired": "false",
      //   "required": false,
      //   "displayOptionsInActions": false,
      //   "globalSearchField": "false",
      //   "controllerId": 1009,
      //   "searchField": "displayName",
      //   "fieldType": "relateAutoComplete",
      //   "populteFields": [],
      //   "displayFields": [
      //     "displayName"
      //   ],
      //   "controllerName": "facilityemployee",
      //   "searchApi": "facilityemployees",
      //   "isMultiple": false,
      //   "textAlign": "Center",
      //   "show": true,
      //   "field": "facilityStaff",
      //   "showOrHideFields": [],
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      // {
      //   "name": "facilityemployee_name",
      //   "type": "text",
      //   "placeholder": "facilityemployee_name",
      //   "label": "facilityemployee_name",
      //   "header": "facilityemployee name",
      //   "width": 110,
      //   "parentField": "facilityStaff",
      //   "id": "facilityemployee_name",
      //   "displayinlist": "true",
      //   "fieldType": "RACSubField",
      //   "textAlign": "Center",
      //   "subFieldName": "name",
      //   "show": true,
      //   "field": "facilityemployee_name",
      //   "mobile": true,
      //   "displayInSettings": true
      // },
      {
        "name": "status",
        "type": "dropDown",
        "placeholder": "Status",
        "label": "Status",
        "width": "100px",
        "addFormOrder": 19,
        "editFormOrder": 19,
        "header": "Status",
        "derivedValue": "status=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "status",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "options": [
          {
            "label": "Created",
            "value": "Created",
            "color": "primary"
          },
          {
            "label": "Assigned",
            "value": "Assigned",
            "color": "primary"
          },
          {
            "label": "Scheduled",
            "value": "Scheduled",
            "color": "primary"
          },
          {
            "label": "Scan Done",
            "value": "Scan Done",
            "color": "primary"
          },
          {
            "label": "Reviewed",
            "value": "Reviewed",
            "color": "primary"
          },
          {
            "label": "Complete",
            "value": "Complete",
            "color": "primary"
          },
          {
            "label": "Notify Dr",
            "value": "Notify Dr",
            "color": "primary"
          }
        ],
        "fieldType": "dropDown",
        "filterElement": [
          {
            "label": "Created",
            "value": "Created",
            "color": "primary"
          },
          {
            "label": "Assigned",
            "value": "Assigned",
            "color": "primary"
          },
          {
            "label": "Scheduled",
            "value": "Scheduled",
            "color": "primary"
          },
          {
            "label": "Scan Done",
            "value": "Scan Done",
            "color": "primary"
          },
          {
            "label": "Reviewed",
            "value": "Reviewed",
            "color": "primary"
          },
          {
            "label": "Complete",
            "value": "Complete",
            "color": "primary"
          },
          {
            "label": "Notify Dr",
            "value": "Notify Dr",
            "color": "primary"
          }
        ],
        "dependent": [],
        "textAlign": "Center",
        "show": true,
        "field": "status",
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true
      }
    ]
    return data;
  };

  getFormFields = () => {
    let { languageData } = this.state
    let statusTypes = [
      {
        label: 'Active',
        value: 'Active'
      },
      {
        label: 'Inactive',
        value: 'Inactive'
      },
      {
        label: 'Pending',
        value: 'Pending'
      },
    ];
    return ([
      {
        "name": "name",
        "type": "text",
        "placeholder": "Name",
        "label": "Name",
        "width": 110,
        "derivedValue": "name=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "id": "name",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "required": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "fieldType": "Link",
        "style": {
          "color": "#0e4768",
          "cursor": "pointer",
          "textTransform": "capitalize"
        },
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "patient",
        "type": "relateAutoComplete",
        "placeholder": "Patient",
        "label": "Patient",
        "width": "90px",
        "derivedValue": "patient=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "patient",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1012,
        "searchField": "displayName",
        "fieldType": "relateAutoComplete",
        "populteFields": [],
        "displayFields": [
          "name"
        ],
        "controllerName": "patients",
        "searchApi": "patientss",
        "isMultiple": false,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder":1,
        "editFormOrder":1,
      },
      {
        "name": "provider",
        "type": "relateAutoComplete",
        "placeholder": "Provider",
        "label": "Provider",
        "width": "90px",
        "derivedValue": "provider=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "provider",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1010,
        "searchField": "name",
        "fieldType": "relateAutoComplete",
        "populteFields": [],
        "displayFields": [
          "name"
        ],
        "controllerName": "providers",
        "searchApi": "providerss",
        "isMultiple": false,
        "show": true,
        "showOrHideFields": [],
        "fieldName": "provider",
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "disable": true
      },
      {
        "name": "scans",
        "type": "relateAutoComplete",
        "placeholder": "Scans",
        "label": "Scans",
        "width": "90px",
        "derivedValue": "Scans=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "Scans",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "false",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1010,
        "searchField": "description",
        "fieldType": "relateAutoComplete",
        "populteFields": [],
        "displayFields": [],
        "controllerName": "scans",
        "searchApi": "scans",
        "isMultiple": true,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder":3,
        "editFormOrder":3,
      },
      {
        "name": "scanDescription",
        "type": "text",
        "placeholder": "Scan Description",
        "label": "Scan Description",
        "width": "90px",
        "derivedValue": "scanDescription=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "scanDescription",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "scanCptCode",
        "type": "text",
        "placeholder": "Scan cpt  code",
        "label": "Scan cpt code",
        "width": "90px",
        "derivedValue": "scanCptCode=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "scanCptCode",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "facility",
        "type": "relateAutoComplete",
        "placeholder": "Facility",
        "label": "Facility",
        "width": "90px",
        "derivedValue": "facility=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "facility",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1011,
        "searchField": "name",
        "fieldType": "relateAutoComplete",
        "populteFields": [],
        "displayFields": [
          "name"
        ],
        "controllerName": "facilities",
        "searchApi": "facilitiess",
        "isMultiple": false,
        "show": true,
        "showOrHideFields": [],
        "fieldName": "facility",
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder":4,
        "editFormOrder":4,
      },
      {
        "name": "phoneNumber",
        "type": "text",
        "placeholder": "Phone Number",
        "label": "Phone Number",
        "width": "90px",
        "derivedValue": "phoneNumber=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "phoneNumber",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "speciality",
        "type": "text",
        "placeholder": "Speciality",
        "label": "Speciality",
        "width": "90px",
        "derivedValue": "speciality=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "speciality",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "Npi",
        "type": "text",
        "placeholder": "NPI",
        "label": "NPI",
        "width": "90px",
        "derivedValue": "Npi=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "Npi",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "fax",
        "type": "text",
        "placeholder": "Fax",
        "label": "Fax",
        "width": "90px",
        "derivedValue": "fax=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "fax",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "nextAppointment",
        "type": "date",
        "placeholder": "Next Appointment Date",
        "label": "Next Appointment Date",
        "width": "90px",
        "derivedValue": "nextAppointment=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "nextAppointment",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false
      },
      {
        "name": "address",
        "type": "textarea",
        "placeholder": "Address",
        "label": "Address",
        "width": "90px",
        "derivedValue": "address=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "address",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "createdBy",
        "type": "relateAutoComplete",
        "placeholder": "CreatedBy",
        "label": "CreatedBy",
        "width": 90,
        "disabled": true,
        "derivedValue": "createdBy=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "createdBy",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "searchField": "displayName",
        "fieldType": "relateAutoComplete",
        "controllerName": "employee",
        "searchApi": "employees",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "updatedBy",
        "type": "relateAutoComplete",
        "placeholder": "UpdatedBy",
        "label": "UpdatedBy",
        "width": 90,
        "derivedValue": "updatedBy=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "updatedBy",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": 1001,
        "searchField": "displayName",
        "disabled": true,
        "fieldType": "relateAutoComplete",
        "controllerName": "employee",
        "searchApi": "employees",
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "updated",
        "type": "date",
        "placeholder": "Updated",
        "label": "Updated",
        "width": 90,
        "derivedValue": "updated=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "updated",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "disabled": true,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "created",
        "type": "date",
        "placeholder": "Created",
        "label": "Created",
        "width": 90,
        "derivedValue": "created=undefined",
        "actions": [],
        "actionsNumber": [],
        "id": "created",
        "displayinaddForm": "false",
        "displayineditForm": "false",
        "displayinlist": "true",
        "globalSearchField": "false",
        "controllerId": null,
        "dateFormat": "DD-MM-YYYY",
        "disabled": true,
        "show": true,
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "physician",
        "type": "relateAutoComplete",
        "placeholder": "Physician",
        "label": "Physician",
        "width": "90px",
        "addFormOrder": 17,
        "editFormOrder": 17,
        "derivedValue": "physician=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "physician",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1008,
        "searchField": "displayName",
        "fieldType": "relateAutoComplete",
        "populteFields": [],
        "displayFields": [
          "displayName"
        ],
        "controllerName": "provideremployee",
        "searchApi": "provideremployees",
        "isMultiple": false,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": false,
        "isEditFormHidden": false,
        "addFormOrder":5,
        "editFormOrder":5,
      },
      {
        "name": "facilityStaff",
        "type": "relateAutoComplete",
        "placeholder": "Facility Staff",
        "label": "Facility Staff",
        "width": "90px",
        "addFormOrder": 18,
        "editFormOrder": 18,
        "derivedValue": "facilityStaff=undefined",
        "capitalizeTableText": false,
        "sortable": false,
        "actions": [],
        "actionsNumber": [],
        "id": "facilityStaff",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "false",
        "required": false,
        "displayOptionsInActions": false,
        "globalSearchField": "false",
        "controllerId": 1009,
        "searchField": "displayName",
        "fieldType": "relateAutoComplete",
        "populteFields": [],
        "displayFields": [
          "displayName"
        ],
        "controllerName": "facilityemployee",
        "searchApi": "facilityemployees",
        "isMultiple": false,
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true
      },
      {
        "name": "status",
        "type": "dropDown",
        "placeholder": "Status",
        "label": "Status",
        "width": "120px",
        "addFormOrder": 19,
        "editFormOrder": 19,
        "derivedValue": "status=undefined",
        "capitalizeTableText": false,
        "sortable": true,
        "filter": true,
        "actions": [],
        "actionsNumber": [],
        "id": "status",
        "displayinaddForm": "true",
        "displayineditForm": "true",
        "displayinlist": "true",
        "isFieldRequired": "true",
        "required": true,
        "displayOptionsInActions": false,
        "globalSearchField": "true",
        "controllerId": null,
        "options": [
          {
            "label": "Created",
            "value": "Created",
            "color": "primary"
          },
          {
            "label": "Assigned",
            "value": "Assigned",
            "color": "primary"
          },
          {
            "label": "Scheduled",
            "value": "Scheduled",
            "color": "primary"
          },
          {
            "label": "Scan Done",
            "value": "Scan Done",
            "color": "primary"
          },
          {
            "label": "Reviewed",
            "value": "Reviewed",
            "color": "primary"
          },
          {
            "label": "Complete",
            "value": "Complete",
            "color": "primary"
          },
          {
            "label": "Notify Dr",
            "value": "Notify Dr",
            "color": "primary"
          }
        ],
        "fieldType": "dropDown",
        "filterElement": [
          {
            "label": "Created",
            "value": "Created",
            "color": "primary"
          },
          {
            "label": "Assigned",
            "value": "Assigned",
            "color": "primary"
          },
          {
            "label": "Scheduled",
            "value": "Scheduled",
            "color": "primary"
          },
          {
            "label": "Scan Done",
            "value": "Scan Done",
            "color": "primary"
          },
          {
            "label": "Reviewed",
            "value": "Reviewed",
            "color": "primary"
          },
          {
            "label": "Complete",
            "value": "Complete",
            "color": "primary"
          },
          {
            "label": "Notify Dr",
            "value": "Notify Dr",
            "color": "primary"
          }
        ],
        "dependent": [],
        "show": true,
        "showOrHideFields": [],
        "mobile": true,
        "displayInSettings": true,
        "isAddFormHidden": true,
        "isEditFormHidden": true,
        "defaultValue": {
          "label": "Created",
          "value": "Created",
          "color": "primary"
        }
      }
    ]);
  }

  submit = async (item) => {

    this.setState({ isOpenFormModal: true })
    await this.formModalRef.getRowData(item, 'edit');

    console.log("Submit Button in sode          ")
  }
  getMobileTableFields = () => {
    let data = [{"textAlign":"center","width":47,"field":"Check Box","label":"Check Box","fieldType":"multiple","header":"","selectionMode":"multiple","show":true,"mobile":true,"displayInSettings":true},{"textAlign":"center","width":47,"field":"Sno","label":"SNo","header":"SNo","filter":false,"sortable":false,"placeholder":"Search","show":true,"mobile":true,"displayInSettings":true},{"name":"name","type":"text","placeholder":"Name","label":"Name","width":110,"header":"Name","derivedValue":"name=undefined","capitalizeTableText":false,"sortable":true,"filter":true,"id":"name","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","required":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"name","showOrHideFields":[],"mobile":true,"displayInSettings":true,"fieldType":"Link","style":{"color":"#0e4768","cursor":"pointer","textTransform":"capitalize"}},{"name":"patient","type":"relateAutoComplete","placeholder":"Patient","label":"Patient","width":"90px","header":"Patient","derivedValue":"patient=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"patient","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1012,"searchField":"name","fieldType":"relateAutoComplete","populteFields":[],"displayFields":["name"],"controllerName":"patients","searchApi":"patientss","isMultiple":false,"textAlign":"Center","show":true,"field":"patient","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"patients_name","type":"text","placeholder":"patients_name","label":"patients_name","header":"patients name","width":110,"parentField":"patient","id":"patients_name","displayinlist":"true","fieldType":"RACSubField","textAlign":"Center","subFieldName":"name","show":true,"field":"patients_name","mobile":true,"displayInSettings":true},{"name":"provider","type":"relateAutoComplete","placeholder":"Provider","label":"Provider","width":"90px","header":"Provider","derivedValue":"provider=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"provider","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1010,"searchField":"name","fieldType":"relateAutoComplete","populteFields":[],"displayFields":["name"],"controllerName":"providers","searchApi":"providerss","isMultiple":false,"textAlign":"Center","show":true,"field":"provider","showOrHideFields":[],"fieldName":"provider","mobile":true,"displayInSettings":true},{"name":"providers_name","type":"text","placeholder":"providers_name","label":"providers_name","header":"providers name","width":110,"parentField":"provider","id":"providers_name","displayinlist":"true","fieldType":"RACSubField","textAlign":"Center","subFieldName":"name","show":true,"field":"providers_name","mobile":true,"displayInSettings":true},{"name":"scanDescription","type":"text","placeholder":"Scan Description","label":"Scan Description","width":"90px","header":"Scan Description","derivedValue":"scanDescription=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"scanDescription","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"scanDescription","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"scanCptCode","type":"text","placeholder":"Scan cpt  code","label":"Scan cpt code","width":"90px","header":"Scan cpt code","derivedValue":"scanCptCode=undefined","capitalizeTableText":false,"sortable":false,"filter":true,"actions":[],"actionsNumber":[],"id":"scanCptCode","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"scanCptCode","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"facility","type":"relateAutoComplete","placeholder":"Facility","label":"Facility","width":"90px","header":"Facility","derivedValue":"facility=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"facility","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1011,"searchField":"name","fieldType":"relateAutoComplete","populteFields":[],"displayFields":["name"],"controllerName":"facilities","searchApi":"facilitiess","isMultiple":false,"textAlign":"Center","show":true,"field":"facility","showOrHideFields":[],"fieldName":"facility","mobile":true,"displayInSettings":true},{"name":"facilities_name","type":"text","placeholder":"facilities_name","label":"facilities_name","header":"facilities name","width":110,"parentField":"facility","id":"facilities_name","displayinlist":"true","fieldType":"RACSubField","textAlign":"Center","subFieldName":"name","show":true,"field":"facilities_name","mobile":true,"displayInSettings":true},{"name":"phoneNumber","type":"text","placeholder":"Phone Number","label":"Phone Number","width":"90px","header":"Phone Number","derivedValue":"phoneNumber=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"phoneNumber","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"phoneNumber","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"speciality","type":"text","placeholder":"Speciality","label":"Speciality","width":"90px","header":"Speciality","derivedValue":"speciality=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"speciality","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"speciality","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"Npi","type":"text","placeholder":"NPI","label":"NPI","width":"90px","header":"NPI","derivedValue":"Npi=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"Npi","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"Npi","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"fax","type":"text","placeholder":"Fax","label":"Fax","width":"90px","header":"Fax","derivedValue":"fax=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"fax","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"fax","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"nextAppointment","type":"date","placeholder":"Next Appointment","label":"Next Appointment","width":"90px","header":"Next Appointment","derivedValue":"nextAppointment=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"nextAppointment","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","show":true,"field":"nextAppointment","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"address","type":"textarea","placeholder":"Address","label":"Address","width":"90px","header":"Address","derivedValue":"address=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"address","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"textAlign":"Center","show":true,"field":"address","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"createdBy","type":"relateAutoComplete","placeholder":"CreatedBy","label":"CreatedBy","width":90,"disabled":true,"header":"CreatedBy","derivedValue":"createdBy=undefined","actions":[],"actionsNumber":[],"id":"createdBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"createdBy","mobile":true,"displayInSettings":true},{"name":"updatedBy","type":"relateAutoComplete","placeholder":"UpdatedBy","label":"UpdatedBy","width":90,"header":"UpdatedBy","derivedValue":"updatedBy=undefined","actions":[],"actionsNumber":[],"id":"updatedBy","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":1001,"searchField":"name","disabled":true,"fieldType":"relateAutoComplete","controllerName":"employee","searchApi":"employees","textAlign":"Center","show":true,"field":"updatedBy","mobile":true,"displayInSettings":true},{"name":"updated","type":"date","placeholder":"Updated","label":"Updated","width":90,"header":"Updated","derivedValue":"updated=undefined","actions":[],"actionsNumber":[],"id":"updated","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","disabled":true,"show":true,"field":"updated","mobile":true,"displayInSettings":true},{"name":"created","type":"date","placeholder":"Created","label":"Created","width":90,"header":"Created","derivedValue":"created=undefined","actions":[],"actionsNumber":[],"id":"created","displayinaddForm":"false","displayineditForm":"false","displayinlist":"true","globalSearchField":"false","controllerId":null,"dateFormat":"DD-MM-YYYY","textAlign":"Center","disabled":true,"show":true,"field":"created","mobile":true,"displayInSettings":true},{"name":"physician","type":"relateAutoComplete","placeholder":"Physician","label":"Physician","width":"90px","addFormOrder":17,"editFormOrder":17,"header":"Physician","derivedValue":"physician=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"physician","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1008,"searchField":"Name","fieldType":"relateAutoComplete","populteFields":[],"displayFields":["Name"],"controllerName":"hospitalemployee","searchApi":"hospitalemployees","isMultiple":false,"textAlign":"Center","show":true,"field":"physician","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"hospitalemployee_Name","type":"text","placeholder":"hospitalemployee_Name","label":"hospitalemployee_Name","header":"hospitalemployee Name","width":110,"parentField":"physician","id":"hospitalemployee_Name","displayinlist":"true","fieldType":"RACSubField","textAlign":"Center","subFieldName":"Name","show":true,"field":"hospitalemployee_Name","mobile":true,"displayInSettings":true},{"name":"facilityStaff","type":"relateAutoComplete","placeholder":"Facility Staff","label":"Facility Staff","width":"90px","addFormOrder":18,"editFormOrder":18,"header":"Facility Staff","derivedValue":"facilityStaff=undefined","capitalizeTableText":false,"sortable":false,"actions":[],"actionsNumber":[],"id":"facilityStaff","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"false","required":false,"displayOptionsInActions":false,"globalSearchField":"false","controllerId":1009,"searchField":"name","fieldType":"relateAutoComplete","populteFields":[],"displayFields":["name"],"controllerName":"facilityemployee","searchApi":"facilityemployees","isMultiple":false,"textAlign":"Center","show":true,"field":"facilityStaff","showOrHideFields":[],"mobile":true,"displayInSettings":true},{"name":"facilityemployee_name","type":"text","placeholder":"facilityemployee_name","label":"facilityemployee_name","header":"facilityemployee name","width":110,"parentField":"facilityStaff","id":"facilityemployee_name","displayinlist":"true","fieldType":"RACSubField","textAlign":"Center","subFieldName":"name","show":true,"field":"facilityemployee_name","mobile":true,"displayInSettings":true},{"name":"status","type":"dropDown","placeholder":"Status","label":"Status","width":"90px","addFormOrder":19,"editFormOrder":19,"header":"Status","derivedValue":"status=undefined","capitalizeTableText":false,"sortable":true,"filter":true,"actions":[],"actionsNumber":[],"id":"status","displayinaddForm":"true","displayineditForm":"true","displayinlist":"true","isFieldRequired":"true","required":true,"displayOptionsInActions":false,"globalSearchField":"true","controllerId":null,"options":[{"label":"Created","value":"Created","color":"primary"},{"label":"Assigned","value":"Assigned","color":"primary"},{"label":"Scheduled","value":"Scheduled","color":"primary"},{"label":"Scan Done","value":"Scan Done","color":"primary"},{"label":"Reviewed","value":"Reviewed","color":"primary"},{"label":"Complete","value":"Complete","color":"primary"},{"label":"Notify Dr","value":"Notify Dr","color":"primary"}],"fieldType":"dropDown","filterElement":[{"label":"Created","value":"Created","color":"primary"},{"label":"Assigned","value":"Assigned","color":"primary"},{"label":"Scheduled","value":"Scheduled","color":"primary"},{"label":"Scan Done","value":"Scan Done","color":"primary"},{"label":"Reviewed","value":"Reviewed","color":"primary"},{"label":"Complete","value":"Complete","color":"primary"},{"label":"Notify Dr","value":"Notify Dr","color":"primary"}],"dependent":[],"textAlign":"Center","show":true,"field":"status","showOrHideFields":[],"mobile":true,"displayInSettings":true}]

    return data;
  };
  closeFormModal = async () => {
    this.setState({
      isOpenFormModal: false,
    })
  }
  // submit1 = item => {
  //   let x = orderssFields
  //   let objorderss = {}

  //   objorderss["_id"] = item[0]["_id"]
  //   for (let x2 of x) {
  //     objorderss[x2] = item[0][x2]
  //   }
  //   let formFields = this.getFormFields()

  //   formFields = formFields.filter(y => x.includes(y.name))

  //   this.setState({
  //     openNewUserModal: true,
  //     item: objorderss,
  //     newFormFields: formFields
  //   });
  // }

  onClickEdit = async (data) => {    
    await this.setState({rowData:data[0],showOrderEdit:true})
  }

  closeEdit = () => {
    this.setState({showOrderEdit:false,editSelectedRecord:false,addSelectedRecord:false});
  }

  
  cancelReset = async (type) => {
    this.setState({
      openNewUserModal: false
    });
    window.location.reload();

    // if (type == "submit") {
    // type == "submit"
    //   ?
    // await this.dataTableRef.getDataFromServer(this.state.filterCriteria, "refresh");
    // }

    // : null;
  };
  getChangedRoleOptions = () => {
    let fields = this.getFormFields();
    if (fields && fields.length > 0) {
      for (let obj of fields) {
        if (obj.name == "role") {
          obj.options = this.state.rolesList && this.state.rolesList.length > 0 ? this.state.rolesList : []
        }
      }
    }
    return fields;
  }
  saveDataToServer = async (item, field, value) => {
    let body = item[0]
    body[field] = value
    let userBody = Object.assign({}, body);
    this.setState({
      isLoading: true
    });
    if (body) {
      let method, apiUrl;
      method = 'PUT';
      apiUrl = `${apiCalls.Orderss}/${body._id}`;
      return fetchMethodRequest(method, apiUrl, userBody)
        .then(async (response) => {
          // let sessionexpired = await localStorage.getItem('sessionexpired')
          // if (sessionexpired === "true") {
          //   await this.setState({ sessionExpiryModal: true })
          // }
          if (response && response.respCode) {
            showToasterMessage(response.respMessage, 'success');

          } else if (response && response.errorMessage) {
            showToasterMessage(response.errorMessage, 'error');
          }
          this.setState({
            isLoading: false
          });
        }).catch((err) => {
          return err;
        });
    } else {
      return;
    }
  }
  render() {
    return (
      <span>
        {!this.state.editSelectedRecord && !this.state.addSelectedRecord && !this.state.showOrderEdit ?
          <DataTables
            {...this.props}
            onRef={ref => (this.dataTableRef = ref)}
            // MobileTableFields={this.getMobileTableFields}
            // getTableFields={this.getTableFields}
            // formFields={this.getFormFields}
            // 
            addRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
            editRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
            deleteRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
            viewRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
            exportRequired={this.state.rolePermission && this.state.rolePermission == 'Edit' ? true : false}
            sample={true}
            // globalSearch={'Display Name/Email'}
            // type='Orderss'
            // apiUrl={apiCalls.Orderss}
            getTableFields={this.getTableFields}
            formFields={this.getChangedRoleOptions}
            // exportRequried={true}

            printRequried={true}
            actionsTypes={[
              {
                'name': 'Edit',
                'action': this.onClickEdit,
                "options": [
                  { 'label': 'Edit', 'value': 'Edit', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": false, },
                ]
              },

              {
                'name': 'Delete',
                "options": [
                  { 'label': 'Delete', 'value': 'Delete', 'show': this.state.rolePermission && this.state.rolePermission == "Edit" ? true : false, "multiple": true, },
                ]
              },

              // {
              //   'name': 'Block',
              //   "options": [
              //     { 'label': 'Block', 'value': 'Block', 'show': true, "multiple": false, }
              //   ]
              // },
              // {
              //   'name': 'ResetPassword',
              //   "options": [
              //     { 'label': 'ResetPassword', 'value': 'ResetPassword', 'show': true, "multiple": false, }
              //   ]
              // },
              // {
              //   'name': 'Submit',
              //   'action': this.submit,
              //   "options": [
              //     { 'label': 'Submit', 'value': 'Submit', 'show': true, "multiple": false },
              //   ]
              // },
              // {
              //   name: "newModel",
              //   action: this.submit1,
              //   options: [
              //     { label: "newModel", value: "newModel", show: true, multiple: false }
              //   ]
              // }

            ]}
            // addRequried={insertAdd}
            // editRequired={true}
            // deleteRequired={true}
            // viewRequired={true}
            settingsRequired={true}
            filterRequired={false}
            gridRequried={true}
            exportToCsv={true}
            dateSearchRequired={false}
            searchInDateRangeField={""}
            sampleFilePath={filePath.orderss}
            setData={this.setData}
            editSelectedRecord={this.state.editSelectedRecord}
            addSelectedRecord={this.state.addSelectedRecord}
            viewSelectedRecord={this.state.viewSelectedRecord}
            globalSearch={"name/scanDescription/scanCptCode/phoneNumber/speciality/Npi/fax/address/status"}
            type='Orders'
            routeTo={apiCalls.Orderss}
            displayViewOfForm='screen'
            apiResponseKey={apiCalls.Orderss}
            apiUrl={apiCalls.Orderss}

          /> : (this.state.editSelectedRecord || this.state.addSelectedRecord || this.state.showOrderEdit) ?

            <OrdersEdit
              financialClassTypes={this.financialClassTypes}
              priorityTypes={this.priorityTypes}
              openOrdersEdit={this.state.showOrderEdit}
              pageType={this.state.addSelectedRecord ? 'add' : 'edit'}
              closeEdit={this.closeEdit}
              routeTo={apiCalls.Orderss}
              data={this.state.rowData}
              apiUrl={apiCalls.Orderss}
              formFields={this.getFormFields}
            /> : null
        }
        {this.state.isOpenFormModal ? (
          <FormModal
            onRef={(ref) => (this.formModalRef = ref)}
            formType="edit"
            openFormModal={this.state.isOpenFormModal}
            formFields={this.props.formFields}
          />

        ) : null}
        {this.state.openNewUserModal ? (
          <NewUserModal
            openNewUserModal={this.state.openNewUserModal}
            cancelReset={this.cancelReset}
            item={this.state.item}
            newFormFields={this.state.newFormFields}
            recordId={this.state.item._id}
            entityType="Orders"
            apiUrl={apiCalls.Orderss}
          />
        ) : null}
      </span>
    );
  }
}